// extracted by mini-css-extract-plugin
export default {"leftwrap":"faceClick_leftwrap__bKbsT","handImg":"faceClick_handImg__CCTHu","guideText":"faceClick_guideText__iK-Mz","linkText":"faceClick_linkText__XXmRP"};